module.exports = __webpack_public_path__ + "img/buildingIcon.1ff22970.png";